import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styles from '../../styles/renewal/OnePageHeader.module.css';
import { noTranslate } from './formatters';

/** 기업 소개 메인 주소 — 헤더에서 되돌아갈 때 쓴다. */
const HOME_PATH = '/';

const NAV = [
  { id: 'about', label: 'BNPL 소개' },
  { id: 'guide', label: '이용안내' },
  { id: 'partner', label: '제휴사모집' },
  { id: 'cases', label: '성공사례' },
  { id: 'faq', label: '소식' },
  { id: 'contact', label: '문의하기' },
];

const OnePageHeader = ({ onNavigate }) => {
  // 좁은 화면에서는 메뉴를 접어 두고 버튼으로 펼친다.
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [menuOpen]);

  const go = useCallback(
    (id) => {
      setMenuOpen(false);
      onNavigate(id);
    },
    [onNavigate]
  );

  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <button type="button" className={styles.brand} onClick={() => go('home')}>
          <img
            className={styles.logo}
            src={`${process.env.PUBLIC_URL}/renewal/logo.png`}
            width="44"
            height="44"
            alt="오퍼그룹"
          />
          <span className={styles.wordmark} translate="no">
            <span className={styles.word}>OFFER</span>
            <span className={`${styles.word} ${styles.wordAccent}`}>GROUP</span>
          </span>
        </button>

        <button
          type="button"
          className={styles.menuBtn}
          aria-controls="offer-main-nav"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          <span className={styles.menuIcon} aria-hidden="true">
            {menuOpen ? '✕' : '☰'}
          </span>
          <span className={styles.menuLabel}>메뉴</span>
        </button>

        <nav
          id="offer-main-nav"
          className={`${styles.nav} ${menuOpen ? styles.navOpen : ''}`}
          aria-label="주요 섹션"
        >
          {NAV.map((item) => (
            <button
              key={item.id}
              type="button"
              className={styles.navItem}
              translate={noTranslate(item.label)}
              onClick={() => go(item.id)}
            >
              {item.label}
            </button>
          ))}
          <button type="button" className={styles.cta} onClick={() => go('contact')}>
            무료 상담
          </button>
          <Link
            className={styles.homeLink}
            to={HOME_PATH}
            onClick={() => setMenuOpen(false)}
          >
            회사소개 ↗
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default OnePageHeader;
